(function(){
  var clock = document.getElementById('clock');
  if(!clock) return;
  var secs = 15*60-1;
  setInterval(function(){
    if(secs<=0) return;
    secs--;
    var m=String(Math.floor(secs/60)).padStart(2,'0');
    var s=String(secs%60).padStart(2,'0');
    clock.textContent=m+':'+s;
  },1000);
})();